import script from "./Destockage.vue?vue&type=script&setup=true&lang=js"
export * from "./Destockage.vue?vue&type=script&setup=true&lang=js"

import "./Destockage.vue?vue&type=style&index=0&id=1917424a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1917424a"]])

export default __exports__